class BaoSsoRedirectManager {
  constructor () {
    const urlParams = new URLSearchParams(window.location.search)
    const urlPath = window.location.pathname
    const checkoutUrl = urlParams.get('checkout_url')
    const supportSignUp = urlParams.get('supportSignUp')
    const supportForgotPassword = urlParams.get('supportForgotPassword')

    if (supportSignUp === 'true' || supportForgotPassword === 'true') {
      window.location = window?.theme?.sso?.loginUrl || '/account/login'
      return
    }

    // If we entered the login page with a checkout_url parameter, store it
    if (urlPath === '/account/login' && checkoutUrl) {
      this.redirectUrl = checkoutUrl
      return
    }

    // If we entered the account page with a stored value, redirect to it
    if (urlPath === '/account' && this.redirectUrl) {
      const redirectUrl = this.redirectUrl
      this.clearStoredRedirectUrl()
      window.location = redirectUrl
      return
    }

    if (urlPath !== '/pages/email-verification') {
      this.clearStoredRedirectUrl()
    }
  }

  get redirectUrl () {
    return localStorage.getItem(this.storageKey)
  }

  set redirectUrl (url) {
    localStorage.setItem(this.storageKey, url)
  }

  clearStoredRedirectUrl () {
    if (this.redirectUrl) {
      localStorage.removeItem(this.storageKey)
    }
  }

  get storageKey () {
    return `ssoRedirectUrl-${this.shop}`
  }

  get shop () {
    return window?.Shopify?.shop || ''
  }
}

window.BAO.ssoRedirectManager = new BaoSsoRedirectManager()
